import axios from 'axios';
import api from './ApiAuthService';

export default class Tips {
  static async getTips(params: any) {
    try {
      console.log('params', params);
      let url = '/posts/tips';
      // if (category_id) {
      //   url += '?category_id=' + category_id;
      // }

      // if (subcategory_id) {
      //   url += '&subcategory_id=' + subcategory_id;
      // }

      // if (search) {
      //   url += '&search=' + search;
      // }

      if (params) {
        url += '?';
      }

      if (params.category) {
        url += 'category_id=' + params.category.value + '&';
      }

      if (params.subCategory) {
        url += 'subcategory_id=' + params.subCategory.value + '&';
      }

      if (params.search) {
        url += 'search=' + params.search + '&';
      }
      
      if (params.country) {
        url += 'country=' + params.country.value + '&';
      }
  
      if (params.state) {
        url += 'state=' + params.state.value + '&';
      }
  
      if (params.city) {
        url += 'city=' + params.city.value + '&';
      }

      if (params.page) {
        url += 'page=' + params.page + '&';
      }

      if (params.per_page) {
        url += 'per_page=' + params.per_page + '&';
      } else {
        url += 'per_page=20&';
      }

      if (url.charAt(url.length - 1) === '&' || url.charAt(url.length - 1) === '?') {
        url = url.slice(0, -1);
      }

      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async getMoreTips(dica_id: number) {
    try {
      const url = '/posts/more-tips/' + dica_id;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async getTipsDetail(dica_id: number) {
    try {
      let url = '/posts/tips/' + dica_id;
      const response = await api.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async post(dados: any) {
    try {
      const response = await api.post("/posts/tips", dados, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async update(id: number, dados: any) {
    try {
      const response = await api.post(("/posts/tips/" + id ), dados, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}